import { render } from "./Loader.vue?vue&type=template&id=4a7deac2&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=4a7deac2&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7deac2"]])

export default __exports__